import { useData, useDispatch } from "./DataContext.js";

import Button from "react-bootstrap/Button";

export default function TitlePage (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    function startTheme (themeId)
    {
	const theme = gData.state.themes[themeId];
	if (theme.state === "done")
	{
	    gDispatch({ type: "openEnd", themeId });
	}
	
	else {
	    //if (! props.fullscreenHandle.active) props.fullscreenHandle.enter();
	    if (gData.content.params.autoFullscreen) document.body.requestFullscreen().catch((err) => {});
	    gDispatch({ type: "openModal", modal: "title" });
	    gDispatch({ type: "startTheme", themeId });
	}
    }

    //const nextThemeId = Object.entries(gData.state.themes).find(([themeId, theme]) => theme.state !== "done")[0];
    const themeButtons = Object.entries(gData.state.themes).map(([id, theme]) => {
	const themeContent = gData.content.themes[theme.id]
	/* disabled={themeId !== nextThemeId}
	   variant={theme.state === "done" || themeId === nextThemeId ? "primary" : "secondary" } */
	return (
	    <Button key={theme.id}
		    disabled={themeContent.disabled}
		    variant={"primary"}
		    style={{ width: "360px" }}
		    onClick={() => startTheme(theme.id)}
	    >
		{themeContent.title}
	    </Button>
	)
    });

    if (gData.gameId === "ada") { return (<></>); }
    return (
	<div className="position-absolute top-50 start-50 translate-middle d-flex flex-column align-items-center gap-2">{themeButtons}</div>
    );
}




/* import { useData, useDispatch } from "./DataContext.js";
 * 
 * import Button from "react-bootstrap/Button";
 * 
 * export default function Themes (props)
 * {
 *     const gData = useData();
 *     const gDispatch = useDispatch();
 * 
 *     function startTheme (themeId)
 *     {
 * 	const theme = gData.state.themes[themeId];
 * 	if (theme.state === "done")
 * 	{
 * 	    gDispatch({ type: "openEnd", themeId });
 * 	}
 * 	
 * 	else {
 * 	    //if (! props.fullscreenHandle.active) props.fullscreenHandle.enter();
 * 	    if (gData.content.params.autoFullscreen) document.body.requestFullscreen();
 * 	    gDispatch({ type: "openModal", modal: "title" });
 * 	    gDispatch({ type: "startTheme", themeId });
 * 	}
 *     }
 * 
 *     //const nextThemeId = Object.entries(gData.state.themes).find(([themeId, theme]) => theme.state !== "done")[0];
 *     const themeButtons = Object.entries(gData.state.themes).map(([id, theme]) => {
 * 	const themeContent = gData.content.themes[theme.id]
 * 	//disabled={themeId !== nextThemeId}
 * 	//variant={theme.state === "done" || themeId === nextThemeId ? "primary" : "secondary" }
 * 	return (
 * 	    <Button key={theme.id}
 * 		    disabled={themeContent.disabled}
 * 		    variant={"primary"}
 * 		    style={{ width: "360px" }}
 * 		    onClick={() => startTheme(theme.id)}
 * 	    >
 * 		{themeContent.title}
 * 	    </Button>
 * 	)
 *     });
 * 
 *     return (
 * 	<div className="position-absolute top-50 start-50 translate-middle d-flex flex-column align-items-center gap-2">{themeButtons}</div>
 *     );
 * } */
